import React, { useEffect } from 'react';
import './App.scss';
import data from './data/content.json';
import { ContentProvider } from './context/ContentProvider';
import { IContent } from './types';
import './App.scss';
import { connect, ConnectedProps } from 'react-redux';
import { RootState, AppDispatch } from './store';
import { bindActionCreators } from 'redux';
import { fetchAppSetup } from './store/features/app/app';
import { getImages, getProductIds, sendWaData } from './utils';
import { fetchUserData } from './store/features/user/user';

import { blocks, default_blocks_order } from "./utils/blocks";

const mapStateToProps = (state: RootState) => ({
  products: state.products,
  app: state.app,
  user: state.user
});

const mapDisPatchToProps = (dispatch: AppDispatch) => ({
  fetchAppSetup: bindActionCreators(fetchAppSetup, dispatch),
  fetchUserData: bindActionCreators(fetchUserData, dispatch)
});

const connector = connect(mapStateToProps, mapDisPatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;
type AppProps = PropsFromRedux & {
  localeId: string;
};

const App = ({
  localeId,
  products,
  fetchAppSetup,
  fetchUserData
}: AppProps) => {
  const contentFound: any = data.filter(
    (locale) => locale.lang === localeId
  );

  if (contentFound.length !== 1) {
    return null;
  }
  const localizedContent: IContent = contentFound[0];
  const productIds = getProductIds(localizedContent);

  const dynamicImages = getImages(localizedContent, '$imageBasePath$');
  if (process.env.NODE_ENV === 'development') {
    window.dynamicImages = dynamicImages;
  }

  useEffect(() => {
    // To be well retrieved from the GoogleSheet, products have to be objects formatted like the IProductSignature interface (with an id and a type)
    fetchAppSetup(productIds !== null ? productIds : undefined);

    document.addEventListener('CONNECT_SDK_LOADED', (e: any) => {
      const sessionData = e.detail;
      fetchUserData(sessionData);
    });
    sendWaData({ siteSection: 'homepage', pageName: 'Homepage - ubisoft forward 3 postshow - uplaystore' });
  }, []);

  const isPrerendered = window.__PRERENDER_INJECTED !== undefined;

  const blocksOrder: string[] =
    localizedContent &&
    localizedContent.blocks_order &&
    // @ts-ignore
    localizedContent.blocks_order[process.env.REACT_APP_PAGE_TYPE]
      ?
      localizedContent.blocks_order[process.env.REACT_APP_PAGE_TYPE].blocks.filter(
        // @ts-ignore
        (order: string) => order && typeof blocks[order] !== 'undefined'
      )
      : default_blocks_order;

  const tagsList = blocksOrder.map((blockName: string, index: number) => {
    // @ts-ignore
    const Block = blocks[blockName];
    if (!Block) {
      return null;
    }
    const TagName = Block.component;
    const params = Block.params || null;
    return (
      <TagName
        key={`block_${index}`}
        {...params}
      />
    );
  });

  return (
    <main id="ubiforward3-landingpage" className={localeId}>
      {isPrerendered ? (
        <script>window.dynamicImages = {JSON.stringify(dynamicImages)}</script>
      ) : null}
      <ContentProvider value={localizedContent}>
        {tagsList}
      </ContentProvider>
    </main>
  );
};
export default connector(App);
